import { useTheme } from "@emotion/react";
import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useSnackbar } from "notistack"

const SnackbarCloseButton = ({snackbarKey}) => {
    const { closeSnackbar } = useSnackbar();
    const theme = useTheme();

    return (
        <IconButton onClick={() => closeSnackbar(snackbarKey)} size="small">
            <Close htmlColor={theme.palette.common.white} />
        </IconButton>
    )
};

export default SnackbarCloseButton;